module.exports = __webpack_public_path__ + "static/PP8-b47c9c289f8fd12bda7dcd1d281f68fa.jpg";